import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {StorageService} from '@services/core/storage/storage.service';

export declare type ApplicationTheme = 'light' | 'dark'

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  static LocalStorageKey = 'current-theme';

  private themeSubject: BehaviorSubject<ApplicationTheme>;
  public theme$: Observable<ApplicationTheme>;

  constructor(private ls: StorageService) {
    this.themeSubject = new BehaviorSubject<ApplicationTheme>('dark');
    this.theme$ = this.themeSubject.asObservable();
  }

  get theme(): ApplicationTheme {
    return this.themeSubject.getValue();
  }

  set theme(c: ApplicationTheme) {
    this.ls.setItem(ThemeService.LocalStorageKey, c);
    this.themeSubject.next(c);
  }
}
